import React from 'react';
import { Link } from 'react-router-dom';
import celebration from './../../assets/images/static/celebration.jpeg';
import guitar from './../../assets/images/static/country-field-grass.jpg';
import './css/index.scss';

class Home extends React.Component {

  componentDidMount(){
    window.scrollTo(0, 0);
    document.title = "Taburi.ro - Tabulaturi pentru chitară, pian și alte instrumente";
  }

  render () {

    return (
      <div className="homeContainer">
        <div className="mainHeader"></div>
        <div className="container">
          <div className="article" style={{ marginTop: '-230px'}}>
            <h1>Bine ați venit!</h1>
            <p>Acest proiect a pornit de la ideea de a oferi pasionaților de muzică și nu numai o colecție de tabulaturi de calitate.</p>
            <p>Contribuțiile trec printr-un proces de corectare, din punct de vedere gramatical și, pe cât posibil, muzical (acordurile să pice exact pe silaba corectă). Bineînțeles, acest proces nu este perfect, de aceea ne bazăm pe voi pentru semnalarea oricăror erori.</p>

            <p className="center">
              <Link to="/adauga-tabulatura" className="contribuie">Contribuie și tu</Link>
            </p>
          </div>
        </div>
        <div className="container">
          <div className="article" style={{ marginTop: '60px'}}>
            <h1>Am (re)lansat!</h1>
            <img alt="" src={celebration} style={{height: '200px', float: 'right', borderRadius: '3px', borderTop: '2px solid #007bd9', marginLeft: '20px'}} />
            <p>
              După îndelungi așteptări și variante, am relansat saitul, în variantă minimă funcțională. <br/><br/> 
              Tot ce se va adăuga de acum înainte (sistem de votare,comentarii, etc.) nu va mai afecta funcționalitățile de bază.<br/> <br/> Deasemenea, ne bazăm pe voi pentru contribuțiile aduse acestui sait, atât în materie de tabulaturi, cât și pentru orice sugestie utilă.
            <br/> <br/> Mulțumim încă o dată pentru răbdare și spor la cântat!</p>
            <div style={{clear: 'both', marginBottom: '10px'}}></div>
          </div>
        </div>
       
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/home/home.js